<template>
<div id="app">
    <nav class="navbar-expand-lg navbar-light navclass">
        <img class="p-3 align-self-center" src="./assets/logo.png" />
        <!-- <a class="navbar-brand" href="/">
      
    </a> -->
        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button> -->

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
                <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Link</a>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dropdown
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">Something else here</a>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link disabled" href="#">Disabled</a>
            </li>
        </ul> -->
        </div>
    </nav>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <Home />
    <br>
    <div class="collab text-center p-4"><h5>In Collaboration With:</h5></div>
    <div class="grid p-4">
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Logo PORI new.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Logo RSCM.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/banner-CISC.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/yki.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Love Pink Indonesia.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan Kanker Payudara Indonesia (YKPI).png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan Kasih Anak Kanker Indonesia (YKAKI).png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan Onkologi Anak Indonesia (YOAI).png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/download.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Pita Tosca.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Aisyiyah Pusat.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Bandung Cancer Society (BCS).jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Fatayat Nahdlatul Ulama.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/gelang HOPE.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/iidi.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Ketua Lovely Pink.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/kisspng-logo-dompet-dhuafa-brand-image-trademark-5b63b77bb6b041.7946945715332616917483.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Koalisi Indonesia Cegah Kanker Serviks (KICKS).png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Komunitas Elgeka Indonesia.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Komunitas Taufan.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Komunitas_Peduli_Kanker_Depok.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/KOWANI transparan.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Logo PKAT.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/logo_dharma_wanita_persatuan.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/love care indonesia.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/LOGO_MRHP_BIRU-03.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/matakin logo.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/MPKU.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Muhammadiyah-logo-4512AA615A-seeklogo.com.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/oase.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/paguyuban pelangi.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Pelkesi.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Perdhaki.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Perkumpulan Profesi Kesehatan Tradisional Komplementer Indonesia (PP KESTRAKI).jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Pink Ribbon Foundation.png')" alt=""></div>
  <!-- <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/PITA KUNING INDONESIA.jpeg')" alt=""></div> -->
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Qalista Peduli Sesama.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Reach to Recovery Surabaya.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Ronald McDonald House Charity Indonesia (RMHC).png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Rumah Singgah Pasien Inisiatif Zakat Indonesia.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Sahabat Kanker Anak Malang.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Srikandi Indonesia.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Think Survive Makassar.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/TP PKK DKI.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Walubi.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan Amaryllis Kirana.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan Kanker Indonesia (YKI) DKI Jakarta.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan Sentuhan Kasih Anak Indonesia (YSKAI).jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Yayasan_Pita_Kuning_Anak_Indonesia-removebg-preview.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/Eka Hospital Logo.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/pink_shimmer_inc.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/RS hermina.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/iccc.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/images (4).png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/logo_lps.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/mika.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/BADAK-removebg-preview.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/primaya.jpg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/DOCCA.jpeg')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/murni_teguh.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/rumah_harapan.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/pbi.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/pim.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/mitra_bti.png')" alt=""></div>
  <div class="logocontainer"><img class="smallimage" :src="require('./assets/logo/manggala.png')" alt=""></div>
</div>
</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Home from './components/Home.vue'

export default {
    name: 'App',
    components: {
        // HelloWorld,
        Home
    }
}
</script>

<style>
#app {
    font-family:Verdana, Geneva, Tahoma, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #F5F7FA;
}

.navclass {
    background-color: #002E4C;
}

.grid {
  display: grid;
  background-color: white;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-gap: 2rem;
  > div {
    background: black;
    padding: 2rem;
    position: relative;
    &::before {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    img {
      /* position: absolute;
      width: 100px;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); */
    }
  }
}

.smallimage{
    max-width: 100px;
    top: 50%;
    left: 50%;
    position: inherit;
}

.logocontainer{
    justify-content: center;
    align-items: center;
    display: flex;
}

.collab{
    background-color: white;
    align-items: center;
    justify-content: center;
}
</style>
